var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconInstallerPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 26,
    viewBox: "0 0 25 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24.4993 18.9686V22.5816C24.5006 22.917 24.4318 23.249 24.2971 23.5563C24.1625 23.8636 23.965 24.1395 23.7174 24.3662C23.4698 24.593 23.1774 24.7656 22.859 24.873C22.5407 24.9805 22.2033 25.0204 21.8686 24.9902C18.1554 24.5875 14.5885 23.3212 11.4547 21.293C8.53906 19.4439 6.06712 16.9769 4.2144 14.067C2.17503 10.9252 0.90589 7.34809 0.509795 3.62554C0.479639 3.29251 0.519297 2.95685 0.626243 2.63995C0.733188 2.32305 0.905079 2.03185 1.13097 1.78488C1.35686 1.53791 1.6318 1.34059 1.93829 1.20548C2.24478 1.07037 2.5761 1.00043 2.91115 1.00012H6.53129C7.11692 0.994364 7.68466 1.20133 8.12869 1.58245C8.57273 1.96356 8.86276 2.49281 8.94472 3.07155C9.09752 4.22778 9.38089 5.36305 9.78942 6.4557C9.95178 6.88675 9.98691 7.35522 9.89067 7.8056C9.79443 8.25597 9.57084 8.66938 9.2464 8.99682L7.71387 10.5263C9.4317 13.5414 11.9331 16.0378 14.9542 17.7522L16.4867 16.2228C16.8148 15.899 17.229 15.6758 17.6803 15.5798C18.1315 15.4837 18.6009 15.5188 19.0328 15.6808C20.1277 16.0885 21.2652 16.3713 22.4237 16.5238C23.0099 16.6064 23.5452 16.901 23.9279 17.3518C24.3106 17.8026 24.5139 18.378 24.4993 18.9686Z",
    stroke: "#3C3C3C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconInstallerPhone);
export default __webpack_public_path__ + "static/media/icon_installer_phone.cc59d2996a032801f0cfd846ad190f37.svg";
export { ForwardRef as ReactComponent };